import 'twin.macro';
import React from 'react';
/* eslint-disable jsx-a11y/label-has-for,react/no-array-index-key */
import { Buttons, Option } from './Buttons';
import Button from '@teetsh/app/src/components/Buttons/Button';
import FormGroup from '../FormGroup';
import { XMarkIcon as X } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';

export interface Props<T> {
  value: T[];
  error?: string;
  touched?: boolean;
  onChange: (value: T[]) => void;
  options: Option<T>[];
  className?: string;
  formGroupClassName?: string;
  label?: string;
  vertical?: boolean;
  canBeEmpty?: boolean;
  clearAll?: boolean;
  small?: boolean;
  fill?: boolean;
  withCustom?: boolean;
  withoutMargin?: boolean;
}

export default function ButtonsRadioMultiple<T = string>(props: Props<T>) {
  const {
    withCustom,
    value,
    vertical,
    onChange,
    error,
    touched,
    options,
    label,
    className,
    canBeEmpty,
    clearAll,
    fill,
    small,
    withoutMargin,
  } = props;
  const { t } = useTranslation(['common']);
  const buttons = (
    <Buttons
      fill={fill}
      small={small}
      onChange={onChange}
      options={options}
      value={value}
      className={className}
      canBeEmpty={canBeEmpty}
      vertical={vertical}
      withCustom={withCustom}
    />
  );
  const clearAllButton = (
    <div tw="text-right mt-1">
      {clearAll && (
        <Button icon={X} onClick={() => onChange([])} minimal small>
          {t('common:buttons.clear')}
        </Button>
      )}
    </div>
  );
  if (!label) {
    return (
      <>
        {buttons}
        {clearAllButton}
      </>
    );
  }
  return (
    <FormGroup
      label={label}
      error={touched ? error : undefined}
      helperText={error && touched ? error : ''}
      withoutMargin={withoutMargin}
    >
      {buttons}
      {clearAllButton}
    </FormGroup>
  );
}
